module.exports = __webpack_public_path__ + "img/9788955138160.bac6153a.jpg";